var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productProductionTrend"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"top_title"},[_vm._v("产品生产趋势")])]),_c('div',{staticClass:"bottom"},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"productProductionTrend"}})])])
}]

export { render, staticRenderFns }